(function ($) {
	$.fn.formSubmissionModal = function () {
		return this.each((i, el) => {
			const $el = $(el);

			//When the modal is closed reset the form
			$el.on('hidden.bs.modal', () => {
				$el.find('form .atd-gf-reset-form-container >input[type="reset"]').trigger('click');
			})
		});
	}

	$(() => {
		const jsVars = window.fr_submission_forms_vars;
		if(jsVars && jsVars.length){
			const selectors = [];
			jsVars.forEach(el => {
				selectors.push('#fr-modal-' + el.url_slug);
			});
			$(selectors.join(', ')).formSubmissionModal();
		}
	});
})($);